import React from 'react'
import { Grid } from '@material-ui/core'
import SiteFilter from './SiteFilter'
import LocusGroupFilter from './LocusGroupFilter'
import LocusFilter from './LocusFilter'
import ExportButton from './ExportButton'

function Filters() {
  return (
    <div className="db-filters">
      <Grid container spacing={2}>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <SiteFilter />
        </Grid>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <LocusGroupFilter />
        </Grid>
        <Grid item lg={2} md={3} sm={6} xs={12}>
          <LocusFilter />
        </Grid>
        <Grid
          item
          container
          lg={6}
          md={3}
          sm={6}
          xs={12}
          justify="flex-end"
          alignContent="center"
          alignItems="center">
          <ExportButton />
        </Grid>
      </Grid>
    </div>
  )
}

export default Filters
